import React from "react";
import { Link } from "react-router-dom";
import { formatDateReadable } from "./helpers";
/**
 * Checks if a date is older than 1 week
 * @param {string} dateString - ISO date string
 * @returns {boolean} True if date is older than 1 week
 */
const isOlderThanOneWeek = (dateString) => {
    if (!dateString) return true;
    const orderDate = new Date(dateString);
    const now = new Date();
    const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    return orderDate < oneWeekAgo;
};

/**
 * Transforms a single log element into table row format
 * @param {Object} element - Log element from API
 * @param {number} index - Index for serial number
 * @returns {Object} Transformed log object
 */
export const latestTransformBlockedOrderItem = (element, index) => {
    const {
        store,
        order_no,
        created_at,
        store_name,
        webpixel_id,
        is_set_webpixel,
        checkout,
        listener_normal,
        listener_headless,
        veeper_normal,
        veeper_headless,
        store_type,
        webpixel,
    } = element;
    const isOld = isOlderThanOneWeek(created_at);
    return {
        store,
        order_no,
        store_type,

        id: index + 1,
        webpixel_id: webpixel_id ? webpixel_id : "N/A",
        is_set_webpixel: is_set_webpixel ? "Yes" : "No",
        created_at: formatDateReadable(created_at),
        webpixel: webpixel ? formatDateReadable(webpixel) : "",
        checkout: checkout ? formatDateReadable(checkout) : "-",
        veeper_normal: veeper_normal ? formatDateReadable(veeper_normal) : "",
        veeper_headless: veeper_headless ? formatDateReadable(veeper_headless) : "",
        listener_normal: listener_normal ? formatDateReadable(listener_normal) : "",
        listener_headless: listener_headless ? formatDateReadable(listener_headless) : "",
        store_name: store ? (
            <Link
                to={{
                    pathname: "/merchant-details",
                    search: `?store=${encodeURIComponent(store)}`,
                    state: { storeStatus: 'active' }
                }}
                className={isOld ? "store-name-highlight store-name-link" : "store-name-link"}
            >
                {store_name || store}
            </Link>
        ) : (isOld ? (
            <span className="store-name-highlight">{store_name}</span>
        ) : store_name),
        __created_at_sort: created_at ? new Date(created_at).getTime() : 0, // Store timestamp for sorting
        ...(isOld && { __rowClassName: 'order-old' }),
    };
};

/**
 * Transforms array of logs into DataTable format
 * @param {Array} orders - Array of blocked order objects from API
 * @param {Array} columns - Table column configuration
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformLatestBlockedOrdersToTableData = (orders, columns) => {
    const blocked_order_list = orders.map((element, index) => latestTransformBlockedOrderItem(element, index));

    return {
        columns,
        rows: blocked_order_list,
    };
};